import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Loader, BaasicTable, BaasicConfirmModal, TableFilter, BaasicHeader, BaasicTableExport, BaasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { fileNames } from 'common/constants';
import { ReceivingExpandList } from 'modules/receiving/pages';

const ReceivingManualListTemplate = ({
	viewStore,
	viewStore: {
		listStore,
		tableData,
		queryUtility,
		loading,
		baasicTableSettingsViewStore,
		expandChange,
		headerCell,
		change,
		columnFilterSetup,
		removeFiltersModal,
		hideReceivedContainers,
		onCheckHideReceivedContainers
	},
	actions,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.CONTAINERS.TITLE" baasicTableSettingsViewStore={baasicTableSettingsViewStore}>
				<div className="layout__main__subheader__item">
					<BaasicCheckbox
						id={'hideReceivedContainers'}
						onChangeCallback={onCheckHideReceivedContainers}
						label="Hide Received Containers"
						checked={hideReceivedContainers}
						className="input--check input--check--negative"
					/>
				</div>
				<BaasicTableExport tableViewStore={viewStore} fileTitle={fileNames.receivingManual} />
			</BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					actions,
					headerCell,
					change,
					expandChange,
					detailComponent: ReceivingExpandList,
					viewStore,
				}}
				data={listStore.data.slice()}
			/>
			<TableFilter viewStore={viewStore} columnFilterSetup={columnFilterSetup} />
			<BaasicConfirmModal modalParams={removeFiltersModal.removeFiltersConfirm} />
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(ReceivingManualListTemplate);
